import React, { useState } from 'react';
import LandingNav from '../landing/components/LandingNav';
import LandingFooter from '../landing/components/LandingFooter';
import ContactForm from './components/ContactForm';
import DemoPanel from './components/DemoPanel';
import Toast from './components/Toast';

export default function ContactPage() {
  const [toast, setToast] = useState(null);

  const handleSubmitSuccess = () => {
    setToast({ message: 'Your message has been sent. We\'ll be in touch within one business day.', type: 'success' });
    setTimeout(() => setToast(null), 5000);
  };

  return (
    <div className="min-h-screen" style={{ background: '#F2F0EC' }}>
      <LandingNav />

      {/* Hero */}
      <section className="pt-32 pb-16 px-6 lg:px-8" style={{ background: '#F2F0EC' }}>
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-caption font-medium mb-6 border" style={{ borderColor: 'rgba(59,76,76,0.15)', color: 'var(--color-secondary)', background: 'rgba(59,76,76,0.04)' }}>
              <span className="w-1.5 h-1.5 rounded-full" style={{ background: '#3b4c4c' }}></span>
              Get in touch
            </div>
            <h1 className="font-heading text-4xl lg:text-5xl font-semibold leading-tight mb-5" style={{ color: 'var(--color-primary)' }}>Let's talk infrastructure equity.</h1>
            <p className="text-lg text-gray-600 font-body leading-relaxed">Whether you're an investor, sponsor, or member of the press, we'd like to hear from you. Fill in the form below or book a demo directly.</p>
          </div>
        </div>
      </section>

      {/* Main content */}
      <section className="">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            {/* Form */}
            <div className="lg:col-span-3">
              <ContactForm onSuccess={handleSubmitSuccess} />
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-2 space-y-6">
              {/* Contact details */}
              <div className="p-6 rounded-xl border" style={{ borderColor: 'var(--color-border)' }}>
                <h3 className="font-heading text-lg font-semibold mb-5" style={{ color: 'var(--color-primary)' }}>Contact details</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(59,76,76,0.07)', color: 'var(--color-primary)' }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                        <polyline points="22,6 12,13 2,6"/>
                      </svg>
                    </div>
                    <div>
                      <div className="text-xs font-caption text-gray-400 mb-0.5">Email</div>
                      <a href="mailto:hello@seeddrive.com" className="text-sm font-body hover:underline" style={{ color: 'var(--color-primary)' }}>hello@seeddrive.com</a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(59,76,76,0.07)', color: 'var(--color-primary)' }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/>
                        <rect x="2" y="9" width="4" height="12"/>
                        <circle cx="4" cy="4" r="2"/>
                      </svg>
                    </div>
                    <div>
                      <div className="text-xs font-caption text-gray-400 mb-0.5">LinkedIn</div>
                      <a href="#" className="text-sm font-body hover:underline" style={{ color: 'var(--color-primary)' }}>linkedin.com/company/seeddrive</a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(59,76,76,0.07)', color: 'var(--color-primary)' }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                        <circle cx="12" cy="10" r="3"/>
                      </svg>
                    </div>
                    <div>
                      <div className="text-xs font-caption text-gray-400 mb-0.5">Office</div>
                      <span className="text-sm font-body text-gray-700">London, United Kingdom</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Demo panel */}
              <DemoPanel />
            </div>
          </div>
        </div>
      </section>

      {/* Toast */}
      {toast && <Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />}

      <LandingFooter />
    </div>
  );
}
